module.exports = __webpack_public_path__ + "img/ico-next.11aba916.svg";